import { PaginationParameters } from 'app/viewmodels/options/pagination-parameters';

export class TableParameters extends PaginationParameters {
  public first: number = 0;
  public rows: number = 10;
}
